const dangerWords = [
  ' script ',
  ' onclick ',
  // ' var ',
  ' let ',
  ' const ',
  ' function ',
  ' alert ',
  ' style ',
  '.js ',
  ' fetch ',
  '=>',
  '()',
  '{',
  '}',
  ';script',
  ';onclick',
  ';var',
  ';let',
  ';const',
  ';function',
  ';alert',
  ';style',
  '.js',
  ';fetch',
  '=>',
  '()',
  '{',
  '}',
];

function checkIfHtmlTextHasJs(htmlText, withAlert) {
  for (const dangerWord of dangerWords) {
    if (htmlText.toLowerCase().includes(dangerWord)) {
      if (withAlert) alert(`В вашем тексте есть слово ${dangerWord}. Если он необходим, то обратитесь разработчику.`);
      return true;
    }
  }

  return false;
}

export default checkIfHtmlTextHasJs;
